import axios from '@/requests';
import { WifiResponse } from '@/store/modules/wifi/types';

export const wifiAPI = {
    async getWifiListByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<WifiResponse[]>('/ComputerInfo/getWifiInfoByUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getOneWifiInfoByUidAndTime(projId: string, uid: string, id: number) {
        try {
            const res = await axios.get<WifiResponse[]>('/ComputerInfo/getOneWifiInfoByUidAndTime', { "projId": projId, "uid": uid, "id": id });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    }
}